// extracted by mini-css-extract-plugin
export default {"loading":"LoadingText_loading__CgnDK","ellipsis":"LoadingText_ellipsis__9h3pd"};